<mat-form-field appearance="outline" class="full-width">
  <input
    type="text"
    matInput
    [placeholder]="placeholder"
    [formControl]="myControl"
    (focus)="onFocus()"
    [matAutocomplete]="auto" />
  @if (myControl.value) {
    <button mat-icon-button matSuffix (click)="resetSelection()" type="button" aria-label="Clear">
      <mat-icon>close</mat-icon>
    </button>
  }
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event)">
    <mat-option *ngFor="let option of filteredOptions" [value]="option">
      {{ option.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
